
import { mapGetters, mapActions } from 'vuex';
export default {
    head: {
        link: [
            {
                rel: 'preload',
                as: 'image',
                href: '/images/animated-secuence/home-banner/banner-animated-secuence-01_420.webp',
                type: 'image/webp',
                imagesrcset: '/images/animated-secuence/home-banner/banner-animated-secuence-01_213.webp 213w, /images/animated-secuence/home-banner/banner-animated-secuence-01_280.webp 280w, /images/animated-secuence/home-banner/banner-animated-secuence-01_420.webp 420w, /images/animated-secuence/home-banner/banner-animated-secuence-01_560.webp 560w',
                imagesizes: '(max-width: 480px) 213px, (max-width: 768px) 280px, (min-width: 769px) 420px'
            },
            { rel: 'preload', as: 'image', href: '/images/background-mural.webp', type: 'image/webp' }
        ]
    },
    components: {
        bannerAnimated			: () => import('../components/home/banner-animated.vue'),
        productCollection	    : () => import('../components/product/product-collection.vue'),
        logoSlider			    : () => import('../components/home/logo-slider.vue'),
        faq					    : () => import('../components/account/faq.vue'),
        vcDynamicLink		    : () => import('../components/pages/dynamic-link.vue'),
        vcCountUp		        : () => import('../components/pages/countup.vue'),
        testimonial			    : () => import('../components/home/testimonial.vue'),
        dynamicComponentLoader  : () => import('../components/pages/dynamic-component-loader.vue'),
    },
    data() {
        return {
            isLoading					: true,
            collection_products			: [],
            bussines_image              : {
                src     : '/images/home/bussines-image_900.webp',
                sizes   : '(max-width: 767px) 100vw, (max-width: 1679px) 50vw, (max-width: 1919px) 800px, (max-width: 2559px) 950px, 1000px',
                srcset  : [
                '/images/home/bussines-image_400.webp 400w',
                '/images/home/bussines-image_600.webp 600w',
                '/images/home/bussines-image_700.webp 700w',
                '/images/home/bussines-image_800.webp 800w',
                '/images/home/bussines-image_900.webp 900w',
                '/images/home/bussines-image_1000.webp 1000w',
                '/images/home/bussines-image_1200.webp 1200w',
                '/images/home/bussines-image_1400.webp 1400w',
                '/images/home/bussines-image_1600.webp 1600w',
                '/images/home/bussines-image_1900.webp 1900w',
                '/images/home/bussines-image_2000.webp 2000w'
                ],
                alt: 'High-quality wholesale Colombian shapewear available at Cata1og.com'
            },
            benefits_image_1            : {
                src     : '/images/home/cata1og-benefits-1_900.webp',
                sizes   : '(max-width: 767px) 100vw, (max-width: 1679px) 50vw, (max-width: 1919px) 800px, (max-width: 2559px) 950px, 1000px',
                srcset  : [
                '/images/home/cata1og-benefits-1_400.webp 400w',
                '/images/home/cata1og-benefits-1_600.webp 600w',
                '/images/home/cata1og-benefits-1_700.webp 700w',
                '/images/home/cata1og-benefits-1_800.webp 800w',
                '/images/home/cata1og-benefits-1_900.webp 900w',
                '/images/home/cata1og-benefits-1_1000.webp 1000w',
                '/images/home/cata1og-benefits-1_1200.webp 1200w',
                '/images/home/cata1og-benefits-1_1400.webp 1400w',
                '/images/home/cata1og-benefits-1_1600.webp 1600w',
                '/images/home/cata1og-benefits-1_1900.webp 1900w',
                '/images/home/cata1og-benefits-1_2000.webp 2000w'
                ],
                alt: 'Premium wholesale waist cinchers for body contouring'
            },
            benefits_image_2            : {
                src     : '/images/home/cata1og-benefits-2_900.webp',
                sizes   : '(max-width: 767px) 100vw, (max-width: 1679px) 50vw, (max-width: 1919px) 800px, (max-width: 2559px) 950px, 1000px',
                srcset  : [
                '/images/home/cata1og-benefits-2_400.webp 400w',
                '/images/home/cata1og-benefits-2_600.webp 600w',
                '/images/home/cata1og-benefits-2_700.webp 700w',
                '/images/home/cata1og-benefits-2_800.webp 800w',
                '/images/home/cata1og-benefits-2_900.webp 900w',
                '/images/home/cata1og-benefits-2_1000.webp 1000w',
                '/images/home/cata1og-benefits-2_1200.webp 1200w',
                '/images/home/cata1og-benefits-2_1400.webp 1400w',
                '/images/home/cata1og-benefits-2_1600.webp 1600w',
                '/images/home/cata1og-benefits-2_1900.webp 1900w',
                '/images/home/cata1og-benefits-2_2000.webp 2000w'
                ],
                alt: 'Explore our wholesale body shapers collection for distributors​'
            },
            cateogry_product_image_1    : {
                src     : '/images/product-category-mural/product-category-jeans_300.webp',
                sizes   : '(max-width: 990px) 50vw, (max-width: 1023px) 33.33vw, (max-width: 1429px) 25vw, (max-width: 1679px) 350px, (max-width: 1919px) 400px, (max-width: 2559px) 475px, 500px',
                srcset  : [
                '/images/product-category-mural/product-category-jeans_256.webp 256w',
                '/images/product-category-mural/product-category-jeans_300.webp 300w',
                '/images/product-category-mural/product-category-jeans_350.webp 350w',
                '/images/product-category-mural/product-category-jeans_400.webp 400w',
                '/images/product-category-mural/product-category-jeans_475.webp 475w',
                '/images/product-category-mural/product-category-jeans_520.webp 520w',
                '/images/product-category-mural/product-category-jeans_700.webp 700w',
                '/images/product-category-mural/product-category-jeans_900.webp 900w'
                ],
                alt: 'Top-rated wholesale compression garments for retailers​'
            },
            cateogry_product_image_2    : {
                src     : '/images/product-category-mural/product-category-shapewear_300.webp',
                sizes   : '(max-width: 990px) 50vw, (max-width: 1023px) 33.33vw, (max-width: 1429px) 25vw, (max-width: 1679px) 350px, (max-width: 1919px) 400px, (max-width: 2559px) 475px, 500px',
                srcset  : [
                '/images/product-category-mural/product-category-shapewear_256.webp 256w',
                '/images/product-category-mural/product-category-shapewear_300.webp 300w',
                '/images/product-category-mural/product-category-shapewear_350.webp 350w',
                '/images/product-category-mural/product-category-shapewear_400.webp 400w',
                '/images/product-category-mural/product-category-shapewear_475.webp 475w',
                '/images/product-category-mural/product-category-shapewear_520.webp 520w',
                '/images/product-category-mural/product-category-shapewear_700.webp 700w',
                '/images/product-category-mural/product-category-shapewear_900.webp 900w'
                ],
                alt: 'Latest trends in wholesale fashion shapewear for B2B buyers​'
            },
            cateogry_product_image_3    : {
                src     : '/images/product-category-mural/product-category-underwear_300.webp',
                sizes   : '(max-width: 990px) 50vw, (max-width: 1023px) 33.33vw, (max-width: 1429px) 25vw, (max-width: 1679px) 350px, (max-width: 1919px) 400px, (max-width: 2559px) 475px, 500px',
                srcset  : [
                '/images/product-category-mural/product-category-underwear_256.webp 256w',
                '/images/product-category-mural/product-category-underwear_300.webp 300w',
                '/images/product-category-mural/product-category-underwear_350.webp 350w',
                '/images/product-category-mural/product-category-underwear_400.webp 400w',
                '/images/product-category-mural/product-category-underwear_475.webp 475w',
                '/images/product-category-mural/product-category-underwear_520.webp 520w',
                '/images/product-category-mural/product-category-underwear_700.webp 700w',
                '/images/product-category-mural/product-category-underwear_900.webp 900w'
                ],
                alt: 'Enhance your inventory with our wholesale shapewear for US distributors'
            },
            cateogry_product_image_4    : {
                src     : '/images/product-category-mural/product-category-accessories_300.webp',
                sizes   : '(max-width: 990px) 50vw, (max-width: 1023px) 33.33vw, (max-width: 1429px) 25vw, (max-width: 1679px) 350px, (max-width: 1919px) 400px, (max-width: 2559px) 475px, 500px',
                srcset  : [
                '/images/product-category-mural/product-category-accessories_256.webp 256w',
                '/images/product-category-mural/product-category-accessories_300.webp 300w',
                '/images/product-category-mural/product-category-accessories_350.webp 350w',
                '/images/product-category-mural/product-category-accessories_400.webp 400w',
                '/images/product-category-mural/product-category-accessories_475.webp 475w',
                '/images/product-category-mural/product-category-accessories_520.webp 520w',
                '/images/product-category-mural/product-category-accessories_700.webp 700w',
                '/images/product-category-mural/product-category-accessories_900.webp 900w'
                ],
                alt: 'Effective body shaping with our wholesale compression wear​'
            },
            swipper_services_options    : {
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 3
                    },
                    640: {
                        slidesPerView: 2
                    }
                }
            },
            swipper_goals_options       : {
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4
                    },
                    768: {
                        slidesPerView: 2
                    },
                    640: {
                        slidesPerView: 1
                    }
                }
            },
            swipper_products_categories : {
                slidesPerView: 2,
                spaceBetween: 0,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4
                    },
                    991: {
                        slidesPerView: 3
                    },
                    768: {
                        slidesPerView: 2
                    },
                    640: {
                        slidesPerView: 2
                    }
                }
            },
            execute_counts_up           : false
        }
    },
    async mounted() {
        
        window.addEventListener('load', this.loadPage);
        window.addEventListener('scroll', this.loadPage);
        
        await this.getCollectionHome();
    },
    computed: {
        ...mapGetters({
            getterCollectionHome: 'getterCollectionHome',
            getterBasicData: 'getterBasicData',
            getterHomeMetrics: 'getterHomeMetrics'
        }),
        getterCallPhone(){
            return this.getterBasicData?.contact_information.phones.find( (item) => item.call );
        },
        changeBrackgroundMural(){
            return this.load_mural ? `background-image: url('/images/home/background-mural.webp')` : '';
        }
    },
    methods: {
        ...mapActions({
            getCollectionHome: 'getCollectionHome'
        }),
        loadPage(event){ 
            const targetSection = document.getElementById('section-goals');
            const rect = targetSection.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
            
            if (this.execute_counts_up === false && isVisible) {
                this.$root.$emit("init-count-up", 'count-up-customers');
                this.$root.$emit("init-count-up", 'count-up-orders');
                this.$root.$emit("init-count-up", 'count-up-brands');
                this.$root.$emit("init-count-up", 'count-up-operate');
                this.execute_counts_up = true;
            }
        }
    }
}
